import { buttonOutlineDark, buttonPrimaryV2 } from '@barracuda/shared/styles/button';
import { theme } from '@theme';

export const navbar = {
  display: 'flex',
  height: '100px !important',
  width: '100%',
  justifyContent: 'space-between',
  position: 'sticky',
  background: 'white',
  zIndex: '1200',
  top: 0,
  '@media only print': {
    display: 'none'
  },
  padding: '24px 48px',
  '@media only screen and (max-width: 540px)': {
    padding: '24px !important'
  }
};

export const navbarDesktop = {
  display: 'flex',
  width: '100%',
  alignItems: 'center'
};

export const navbarList = {
  alignItems: 'center',
  flex: 'none',
  listStyle: 'none',
  paddingInlineStart: 'unset',
  marginLeft: '125px',
  display: {
    mobile: 'none',
    tablet: 'flex'
  }
};

export const navbarNavLoggedIn = {
  flex: 1,
  minWidth: 0
};

export const navbarListLoggedIn = {
  ...navbarList,
  flex: 1,
  minWidth: 0,
  gap: '10px'
};

export const navbarListItem = {
  width: 'auto',
  padding: 0
};

export const navbarLoggedInListSpacer = {
  flex: 1,
  minWidth: 0,
  padding: 0
};

export const navbarLoggedInActionItem = {
  ...navbarListItem,
  flexShrink: 0
};

export const navbarListRight = {
  justifyContent: 'flex-end',
  marginLeft: 'auto',
  paddingLeft: 0,
  gap: '10px'
};

export const linkStyle = {
  color: theme.palette.common.darkGrey6,
  fontSize: '16px',
  lineHeight: 1.5,
  fontWeight: 600,
  fontStyle: 'normal',
  marginRight: '48px',
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.common.violet
  }
};

export const getLinkActiveStyle = (active: boolean) =>
  active ? { color: `${theme.palette.common.violet} !important` } : null;

export const routeLink = {
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '23px',
  color: theme.palette.common.darkGrey3
};

export const signInUpButtonsContainer = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  display: {
    mobile: 'none',
    tablet: 'flex'
  }
};

export const signUpButtonNavbar = {
  ...buttonOutlineDark,
  height: '48px',
  padding: '10px 16px',
  lineHeight: '24px',
  width: '100%'
};

export const signInButtonNavbar = {
  ...buttonPrimaryV2,
  height: '48px',
  padding: '10px 16px',
  width: '100%'
};

export const logoLink = {
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  '@media only screen and (max-width: 1470px)': {
    marginRight: '0 !important'
  }
};

export const logOutStyle = {
  cursor: 'pointer',
  fontSize: '16px',
  fontWeight: 600,
  paddingRight: '16px',
  textTransform: 'none',
  minWidth: 'auto',
  color: 'inherit',
  '&:hover': {
    background: 'transparent'
  }
};

export const navbarRouteBoxStyle = {
  height: '40px',
  marginTop: '90px',
  background: theme.palette.common.lightGrey10,
  display: 'flex',
  width: '100%'
};

export const navbarRouteBoxContainer = {
  display: 'flex',
  marginLeft: '55px',
  '@media screen and (max-width: 540px)': {
    marginLeft: '25px'
  },
  '@media screen and (max-width: 400px)': {
    marginLeft: '5px'
  }
};

export const navbarRouteBoxLinks = {
  display: 'flex',
  padding: '8px',
  gap: '15px'
};

export const navbarLogin = {
  background: 'rgba(13, 0, 77, 0.45)',
  boxShadow: '0 0 16px 0 rgba(8, 9, 9, 0.08)',
  color: 'white',
  '& .MuiTypography-root': { color: 'inherit' },
  '& .MuiButton-root:not(#header-sign-up):not(#header-sign-in)': { color: 'inherit' },
  '& #pte-express-logo': { filter: 'brightness(0) invert(1)' },
  '& #header-sign-in': { backgroundColor: theme.palette.common.buttonPrimaryDefault }
};

export const hamburgerMenuStyle = {
  padding: 0,
  marginLeft: 'auto',
  display: {
    tablet: 'none'
  }
};
